import { DEVICE_HEIGHT, DEVICE_WIDTH } from '../constants/Device';
import styles from '../assets/styles/components/Sidebar.module.scss';
import sidebar from '../assets/images/sideBar.png';
import topBar from '../assets/images/topBar.png';
import logo from '../assets/images/logo.png';
import styled from 'styled-components';

const StyledSideBar = styled.div`
  background-image: url(${DEVICE_WIDTH < 900 ? topBar : sidebar});
`;

export const Sidebar: React.FC<{ firstHeader: string; secondHeader: string; message?: string }> = (props) => {
  return (
    <div className={styles.sidebar} style={{ height: DEVICE_HEIGHT * 0.28 }}>
      <StyledSideBar className={styles.bg_blue} style={{ width: DEVICE_WIDTH, height: DEVICE_HEIGHT * 0.28, backgroundSize: 'cover' }} />
      <div className={styles.logo} style={{ backgroundImage: `url(${logo})` }} />
      <div className={styles.header}>
        <div className={styles.desktopFirstHeader}>{props.firstHeader}</div>
        <div className={styles.secondHeader}>{props.secondHeader}</div>
        <div className={styles.firstHeader}>{props.firstHeader}</div>
        <div className={styles.message}>{props.message}</div>
      </div>
    </div>
  );
};
